import { useEffect, useState ,Fragment} from "react"
import { useDispatch, useSelector } from "react-redux"
import Filter from "./desktop/filter"
import Resort from "./desktop/resort"
import Backdrop from "../../../Backdrop"
import useFetch from '../../../../hook/useFetch'
import { useNavigate } from "react-router-dom"
import InfoIcon from "../../../InfoIcon"
import Skeleton from "react-loading-skeleton"
import { notificationActions } from "../../../../store/notification-slice"
import { faTrash } from "@fortawesome/free-solid-svg-icons"



export default function DesktopComponent() {

    const [desktopitems, setDesktopitems] = useState()

    let statefiles = useSelector(state => state.file.files)

    let filteredfiles = useSelector((state) => state.file.filteredfiles)

    useEffect(() => {

        let items = []
        let files = filteredfiles ?? statefiles

        if (files && Object.keys(files).length > 0) {

            files.forEach((file) => {

                items.push(<DesktopItem key={file.id} file={file} />)

            })
        }
        setDesktopitems(items)



    }, [filteredfiles, statefiles])

   
    if (!desktopitems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            <div className="table-responsive files-table-scroll">
            <table className="table table-striped table-bordered files-table" >
                <colgroup>
                    <col className="files-col-id" />
                    <col className="files-col-name" />
                    <col className="files-col-preview" />
                    <col className="files-col-storepath" />
                    <col className="files-col-path" />
                    <col className="files-col-identifier" />
                    <col className="files-col-type" />
                    <col className="files-col-created" />
                    <col className="files-col-actions" />
                </colgroup>
                <thead>
                    <tr>

                        <th>ID <Resort type='id' /></th>
                        <th>Name <Resort type='name' /></th>
                        <th>Preview</th>
                        <th>StorePath <Resort type='storepath' /></th>
                        <th>Path <Resort type='path' /></th>
                        <th>Identifier <Resort type='identifier' /></th>
                        <th>Type <Resort type='type' /></th>
                        <th>CreatedOn <Resort type='created_on' /></th>
                        <th className="files-actions-cell">Actions</th>


                    </tr>
                </thead>
                <tbody>
                    {desktopitems}
                </tbody>
            </table>
            </div>
        </Filter>
        <Backdrop />

    </Fragment>
}

function DesktopItem(props) {
    const { file } = props
  
    const { del } = useFetch()

    let dispatch = useDispatch()

    let navigate = useNavigate()

    return <Fragment>

        <tr>

            <td>
                {file.id}
            </td>
            <td>
                {file.name}
            </td>
            <td>
            <a href={file.path} target="_blank" rel="noreferrer"><img src={`${file.path}`} className="card-img-top" width={50} height={50} alt={`Preview of ${file.name}`} /></a>
            </td>
            <td>
                {file.storepath}
            </td>
            <td>
                <a href={file.path} target="_blank" rel="noreferrer">{file.path}</a>
            </td>
            <td className="files-actions-cell">
                {file.identifier}
            </td>
            <td>
                {file.type}
            </td>
            <td>
                {file.created_on}
            </td>
            <td>
                <button type="button" className="btn btn-warning" onClick={() => {
                    del(`/admin/file`, { identifier: file.identifier }, (data) => {
                        dispatch(notificationActions.setNotification({
                            message: data,
                            status: false
                        }))
                    },
                        () => {
                            dispatch(notificationActions.setNotification({
                                message: `log deleted`,
                                status: true
                            }))


                            navigate('/admin/files', {
                                state: {
                                    refetch: true
                                }
                            })
                        }
                    )
                }} ><InfoIcon icon={faTrash} title='delete file' /></button>
            </td>


        </tr>

    </Fragment>

}
